<template>
    <div class="view-toggle">
        <b-button
            variant="primary"
            @click="toggleView('list-view')"
            :class="{ active: value === 'list-view' }"
            title="List View"
        >
        <img src="../../assets/list_view.svg" alt="List View" />
        </b-button>
        <b-button
            variant="primary"
            @click="toggleView('grid-view')"
            :class="{ active: value === 'grid-view' } "
            title="Grid View"
        >
        <img src="../../assets/grid_view.svg" alt="Grid View" />
        </b-button>
    </div>
</template>

<script>
export default {
  name: 'view-toggle',
  props: {
    'value': {
      type: String,
      required: true
    }
  },
  methods: {
    toggleView: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">@import '~@scss/custom.scss';

.view-toggle {
    .btn {
        background: var(--main-product-toggle-filter-background-color);
        cursor: pointer;
        padding: .25em;
        width: 3.25em;
        height: 3.25em;
        border-radius: 3px;
        border: 0px;

        img {
            display: flex;
        }

        @include hover {
            background: var(--main-product-toggle-filter-highlight-background-color);
        }

        &.active {
            background: var(--main-product-toggle-filter-background-active-color);

            @include hover {
                background: var(--main-product-toggle-filter-background-highlight-active-color);
            }
        }
    }
}

</style>
